<template>
  <div>
    <v-form
      v-model="valid"
      lazy-validation
      ref="form"
      class="px-3"
      @submit.prevent="onSubmit"
    >
      <v-row justify="center" align="center">
        <v-col cols="12" md="4">
          <v-text-field
            class="my-3"
            color="secondary"
            v-model="contact.name"
            :error-messages="nameErrors"
            label="Nombre"
            required
            @input="$v.contact.name.$touch()"
            @blur="$v.contact.name.$touch()"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            class="my-3"
            color="secondary"
            v-model="contact.email"
            :error-messages="emailErrors"
            label="E-mail"
            required
            @input="$v.contact.email.$touch()"
            @blur="$v.contact.email.$touch()"
          ></v-text-field
        ></v-col>
        <v-col cols="12" md="4">
          <v-text-field
            class="my-3"
            color="secondary"
            v-model="contact.phone"
            :counter="11"
            :error-messages="phoneErrors"
            label="Teléfono"
            hint="Colocar el número sin el 0 y el 15"
            required
            @input="$v.contact.phone.$touch()"
            @blur="$v.contact.phone.$touch()"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            clearable
            clear-icon="mdi-close-circle"
            outlined
            no-resize
            rows="5"
            class="my-3"
            color="secondary"
            v-model="contact.message"
            :counter="1024"
            :error-messages="messageErrors"
            label="Mensaje"
            required
            @input="$v.contact.message.$touch()"
            @blur="$v.contact.message.$touch()"
          ></v-textarea
        ></v-col>
        <v-col cols="12" md="8"
          ><vue-recaptcha
            ref="recaptcha"
            @verify="onVerify"
            @expired="onExpired"
            :loadRecaptchaScript="true"
            :sitekey="sitekey"
          >
          </vue-recaptcha>
          <span
            v-show="showRecaptchaError"
            class="error--text text-caption pl-3"
            >Demuestra que no eres un robot!</span
          ></v-col
        >
        <v-col cols="12" md="4">
          <v-btn
            :disabled="!valid"
            :loading="isSending"
            color="success"
            type="submit"
            block
          >
            Enviar
            <v-icon class="rounded" right>mdi-send</v-icon>
            <template v-slot:loader>
              <span>Enviando...</span>
            </template></v-btn
          >
        </v-col>
      </v-row>
    </v-form>
    <v-progress-linear
      :active="isSending"
      :indeterminate="isSending"
      absolute
      bottom
      color="primary"
    ></v-progress-linear>
    <the-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :icon="snackbarIcon"
      :message="snackbarMessage"
      v-bind="$attrs"
    >
      <v-btn right text class="white--text" @click="snackbar = false"
        >cerrar</v-btn
      >
    </the-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  email,
  minLength,
  numeric
} from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";
import TheSnackbar from "@/components/TheSnackbar";
export default {
  mixins: [validationMixin],
  components: {
    VueRecaptcha,
    TheSnackbar
  },
  data: () => ({
    contact: {
      name: "",
      email: "",
      phone: "",
      message: ""
    },
    sitekey: "6Le2ASoaAAAAALFcufsClKV79z1SeanjsOTgUoPH",
    recaptchaVerified: "",
    showRecaptchaError: false,
    valid: false,
    isSending: false,
    snackbar: false,
    snackbarMessage: "",
    snackbarColor: "",
    snackbarIcon: ""
  }),
  validations: {
    contact: {
      name: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      phone: {
        numeric,
        maxLength: maxLength(11)
      },
      message: {
        required,
        minLength: minLength(20),
        maxLength: maxLength(1024)
      }
    }
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.contact.name.$dirty) return errors;
      !this.$v.contact.name.minLength &&
        errors.push("El nombre debe tener más de 3 carácteres");
      !this.$v.contact.name.required &&
        errors.push("El nombre es obligatiorio.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.contact.email.$dirty) return errors;
      !this.$v.contact.email.email && errors.push("Ingrese un email válido");
      !this.$v.contact.email.required && errors.push("El email es obligatorio");
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.contact.phone.$dirty) return errors;
      !this.$v.contact.phone.numeric && errors.push("Ingrese un número válido");
      !this.$v.contact.phone.maxLength &&
        errors.push("El número debe contener hasta 11 dígitos");
      return errors;
    },
    messageErrors() {
      const errors = [];
      if (!this.$v.contact.message.$dirty) return errors;
      !this.$v.contact.message.minLength &&
        errors.push("El mensaje debe tener más de 20 carácteres");
      !this.$v.contact.message.maxLength &&
        errors.push("El mensaje no puede tener más 300 carácteres");
      !this.$v.contact.message.required &&
        errors.push("El mensaje es obligatorio");
      return errors;
    }
  },
  methods: {
    clear() {
      this.$v.$reset();
      this.resetRecaptcha();
      this.showRecaptchaError = false;
      this.recaptchaVerified = "";
      this.valid = true;
      this.isSending = false;
      this.contact.name = "";
      this.contact.email = "";
      this.contact.phone = "";
      this.contact.message = "";
    },
    onSubmit() {
      this.$v.$touch();
      if (this.recaptchaVerified && this.valid === true) {
        this.valid = false;
        this.isSending = true;
        let form = new FormData();
        for (let field in this.contact) {
          form.append(field, this.contact[field]);
        }
        axios
          .post("https://argecam.com.ar/api/sendMail", form)
          .then(response => {
            this.snackbar = response.data.sent;
            this.snackbarIcon = response.data.icon;
            this.snackbarMessage = response.data.message;
            this.snackbarColor = response.data.color;
            this.clear();
          })
          .catch(() => {
            this.snackbar = true;
            this.snackbarMessage =
              "Ocurrión un problema! intente de nuevo en unos minutos...";
            this.snackbarColor = "error";
            this.snackbarIcon = "mdi-email-alert";
            this.isSending = false;
            this.valid = true;
            this.resetRecaptcha();
          });
      } else {
        this.showRecaptchaError = true;
        this.valid = false;
      }
    },
    onVerify(response) {
      this.recaptchaVerified = response;
      this.showRecaptchaError = false;
      this.valid = true;
    },
    onExpired() {
      console.log("Expired");
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    }
  }
};
</script>
